import React, {Component} from 'react';
import {
    Button,
    DatePicker,
    Form,
    Input,
    Select,
    Typography,
    Checkbox,
    Cascader,
    Divider,
    Result,
    Alert,
    notification
} from "antd";
import axios from "axios";
import {API_URI} from "../../../constant/Config";
import {t, DATE_FORMAT, DATE_FORMAT_API} from '../../../constant/i18n';
import {THEME} from '../../../constant/theme';
import {NATIONALITIES, COUNTRIES_ISO, getCountryLabel, filterCountryOption, countrySearchText} from '../../../constant/countries';
import {FAVOURITE_PHONE_PREFIXES, OTHER_PHONE_PREFIXES, filterPhonePrefixOption, phonePrefixSearchText} from '../../../constant/phonePrefixes';
import {PRO_SITUATIONS, getProSituationLabel} from '../../../constant/proSituations';
import {Redirect} from "react-router-dom";

const {Title, Text, Link} = Typography;
const layout = {
    labelCol: {span: 24},
    wrapperCol: {span: 24},
};
const tailLayout = {
    wrapperCol: {offset: 0, span: 24},
};


class FormRegister extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dataMembre: {
                goNext: false,
                goSuccess: false,
                member_cv: '',
                member_prenom: '',
                member_nom: '',
                member_mdp: '',
                member_age: '',
                member_nationalite: '',
                member_pays_naissance: '',
                member_email: '',
                member_adresse: '',
                member_ville: '',
                member_cp: '',
                member_pays_permanent: '',
                member_tel1: '',
                member_tel2: '',
                member_conturg_civ: '',
                member_conturg_prenom: '',
                member_conturg_nom: '',
                member_conturg_lienvolontaire: '',
                member_conturg_tel1: '',
                member_conturg_email1: '',
                member_situation: '',
                member_situationdepart: '',
                member_form_nom_etab: '',
                member_niv_etude: '',
                member_specialite: '',
                member_nom_formation: '',
                member_autre_form: '',
                dateNaissance: '',
                alerte: false,
                loading: false,
            }
        }
    }


    onFinish = async values => {

        this.setState({loading: true});
        const testEmail = await axios.post(API_URI + '/api-member/membre-test-exist', values);

        if (testEmail.data.exist) {
            // si le membre existe déjà refuser
            notification.info({
                message: t('orderFlight.notif'),
                description: t('formRegister.emailExists')
            });
        } else {
            // si le membre existe pas

            var valPost = {...values, dateNaissance: this.state.dateNaissance}

            // console.log('Success:', values);
            // const res = await axios.post(API_URI + '/api_member/bac_a_sable', valPost);

            const res = await axios.post(API_URI + '/api_member/creat_member', valPost);
            localStorage.setItem('membre_token', res.data.membre_token)
            localStorage.setItem('membre_id', res.data.membre_id)
            localStorage.setItem('membre_nom', res.data.membre_nom)
            localStorage.setItem('membre_prenom', res.data.membre_prenom)
            this.setState({goSuccess: true, alerte: false})
        }
        this.setState({loading: false});

    };

    /**
     * Le but de cette fonction est de récupérer la date string pour palier au problème de la date envoyée -1j
     * mise à jour du state puis envoi au format FR
     *
     * @param date
     * @param dateString
     */
    onChangeDateNaissance = (date, dateString) => {
        // Stockage canonique DD/MM/YYYY pour l'API, indépendant du format affiché.
        this.setState({dateNaissance: date ? date.format(DATE_FORMAT_API) : ''})
    };

    finishSubscribe = () => {
        this.setState({loading: true});
        this.setState({goNext: true})
        this.setState({loading: false});
    }

    onFinishFailed = errorInfo => {
        this.setState({loading: true});
        console.log('Failed:', errorInfo);
        this.setState({
            alerte: <div><Alert message={t('formRegister.missingInfo')}
                                type="warning" showIcon closable/><br/></div>
        })
        this.setState({loading: false});
    };

    testPassword = (password) => {
        this.setState({passeInsert: true});
        var passValue = password.target.value;

        if (passValue.length >= 8) {
            return true;
        } else {
            return false;
        }
    }

    render() {
        if (this.state.goNext) {
            return <Redirect to="/order/check"/>;
        }

        if (this.state.goSuccess) {
            let message = <div>
                {t('formRegister.spaceAllowsYou')}
                <br/><br/>

                {t('formRegister.allow1')}<br/>
                {t('formRegister.allow2')}<br/>
                {t('formRegister.allow3')}<br/>
                {t('formRegister.allow4')}<br/>
                {t('formRegister.allow5')}<br/>
                {t('formRegister.allow6')}<br/>

                <br/><br/>
                {t('formRegister.navigationHelp')}
                <br/><br/>
                {t('formRegister.moreInfo')} <a
                href={'mailto:' + THEME.email}>{THEME.email}</a>
                <br/>
                {t('formRegister.phoneAppointment')} <a
                href={THEME.urls.appointment} target="_blank">{t('formRegister.clickAvailability')}</a> {t('formRegister.andBook')}
                <br/>
                <br/>
                <br/>
                {t('formRegister.bestRegards')}<br/>
                <strong>{t('formRegister.globalongTeam')}</strong>
                <a href={THEME.urls.site} target="_blank">{THEME.urls.site}</a>
            </div>
            return (<div>
                <Result
                    status="success"
                    title={t('formRegister.thanksCreated')}
                    subTitle={message}
                    extra={[
                        <Button type="primary" key="console" onClick={this.finishSubscribe}>
                            {t('formRegister.backToRegistration')}
                        </Button>
                    ]}
                />
            </div>);
        }

        return (
            <div>
                <div className="centerTxt mb10 mt10">
                    <Title level={3}>{t('formRegister.title')}</Title>
                </div>
                <Form
                    {...layout}
                    name="basic"
                    initialValues={{remember: true}}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >

                    <Form.Item
                        label={t('passport.civility')}
                        name="member_cv"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_cv}
                    >
                        <Select style={{width: 120}}>
                            <option value="mr">{t('profil.mr')}</option>
                            <option value="mme">{t('profil.mme')}</option>
                        </Select>

                    </Form.Item>

                    <Form.Item
                        label={t('orderTransactions.firstName')}
                        name="member_prenom"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_prenom}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label={t('orderTransactions.lastName')}
                        name="member_nom"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_nom}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label={t('profil.birthDate')}
                        name="member_age"
                        rules={[{required: true, message: t('formRegister.dateFormat')}]}
                    >
                        <DatePicker style={{width: "100%"}} format={DATE_FORMAT}
                                    onChange={this.onChangeDateNaissance}/>
                    </Form.Item>

                    <Form.Item
                        label={t('profil.nationality')}
                        name="member_nationalite"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_nationalite || undefined}
                    >
                        <Select
                            style={{width: "100%"}}
                            showSearch
                            placeholder={t('common.searchPlaceholder')}
                            notFoundContent={t('common.noResult')}
                            filterOption={filterCountryOption}
                        >
                            {NATIONALITIES.map(c => (
                                <option key={c.value} value={c.value} data-search={countrySearchText(c)}>{getCountryLabel(c)}</option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={t('formRegister.countryBirth')}
                        name="member_pays_naissance"
                        rules={[{required: true, message: t('profil.usernameRequired')}]}
                        initialValue={this.state.dataMembre.member_pays_naissance || undefined}
                    >
                        <Select
                            style={{width: "100%"}}
                            showSearch
                            placeholder={t('common.searchPlaceholder')}
                            notFoundContent={t('common.noResult')}
                            filterOption={filterCountryOption}
                        >
                            {COUNTRIES_ISO.map(c => (
                                <option key={c.value} value={c.value} data-search={countrySearchText(c)}>{getCountryLabel(c)}</option>
                            ))}
                        </Select>

                    </Form.Item>

                    <Form.Item
                        label={t('common.email')}
                        name="member_email"
                        rules={[{type: 'email', required: true, message: t('formRegister.validEmail')}]}
                        initialValue={this.state.dataMembre.member_email}

                    >
                        <Input/>
                    </Form.Item>


                    <Form.Item
                        name="member_mdp"
                        label={t('profil.password')}

                        rules={[
                            {
                                required: this.state.passeInsert,
                                message: t('profil.providePassword'),
                            },
                            (this.state.passeInsert ? ({getFieldValue}) => ({
                                validator(_, value) {
                                    if (value.length > 7) {
                                        return Promise.resolve();
                                    }

                                    return Promise.reject(new Error(t('profil.passwordMinLength')));
                                },
                            }) : false)
                        ]}
                        hasFeedback
                    >
                        <Input.Password onChange={(e) => {
                            this.testPassword(e)
                        }}/>
                    </Form.Item>

                    <Form.Item
                        name="confirm"
                        label={t('profil.confirmPassword')}
                        dependencies={['password']}
                        hasFeedback
                        rules={[
                            {
                                required: this.state.passeInsert,
                                message: t('profil.confirmPasswordRule'),
                            },
                            ({getFieldValue}) => ({
                                validator(_, value) {
                                    if (!value || getFieldValue('member_mdp') === value) {
                                        return Promise.resolve();
                                    }

                                    return Promise.reject(new Error(t('profil.samePasswordRule')));
                                },
                            }),
                        ]}
                    >
                        <Input.Password/>
                    </Form.Item>


                    <Divider dashed/>
                    <Title level={4}>{t('formRegister.permanentAddress')}</Title>
                    <Form.Item
                        label={t('passport.streetAndNum')}
                        name="member_adresse"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_adresse}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label={t('orderTransactions.city')}
                        name="member_ville"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_ville}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label={t('profil.cp')}
                        name="member_cp"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_cp}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label={t('listeCmd.country')}
                        name="member_pays_permanent"
                        rules={[{required: true, message: t('profil.usernameRequired')}]}
                        initialValue={this.state.dataMembre.member_pays_permanent || undefined}
                    >
                        <Select
                            style={{width: "100%"}}
                            showSearch
                            placeholder={t('common.searchPlaceholder')}
                            notFoundContent={t('common.noResult')}
                            filterOption={filterCountryOption}
                        >
                            {COUNTRIES_ISO.map(c => (
                                <option key={c.value} value={c.value} data-search={countrySearchText(c)}>{getCountryLabel(c)}</option>
                            ))}
                        </Select>

                    </Form.Item>

                    <Form.Item label={t('profil.mobilePhone')}>
                        <Input.Group compact={true}>


                            <Form.Item

                                name="member_tel1_prefix"
                                rules={[{required: true, message: t('formRegister.phonePrefixRequired')}]}
                            >
                                <Select
                                    style={{minWidth: "250px"}}
                                    showSearch
                                    placeholder={t('common.searchPlaceholder')}
                                    notFoundContent={t('common.noResult')}
                                    filterOption={filterPhonePrefixOption}
                                >
                                    <Select.OptGroup label={t('formRegister.preferredPrefixes')}>
                                        {FAVOURITE_PHONE_PREFIXES.map(p => (
                                            <option
                                                key={p.code + p.value}
                                                data-countrycode={p.code}
                                                value={p.value}
                                                data-search={phonePrefixSearchText(p)}
                                                data-dial={p.value.replace('+', '')}
                                            >{p.label}</option>
                                        ))}
                                    </Select.OptGroup>
                                    <Select.OptGroup label={t('formRegister.allCountries')}>
                                        {OTHER_PHONE_PREFIXES.map(p => (
                                            <option
                                                key={p.code + p.value}
                                                data-countrycode={p.code}
                                                value={p.value}
                                                data-search={phonePrefixSearchText(p)}
                                                data-dial={p.value.replace('+', '')}
                                            >{p.label}</option>
                                        ))}
                                    </Select.OptGroup>
                                </Select>

                            </Form.Item>

                            <Form.Item
                                name="member_tel1"
                                rules={[{required: true, message: t('common.completeInfo')}]}
                                initialValue={this.state.dataMembre.member_tel1}

                            >
                                <Input placeholder={t('formRegister.phoneExample')} style={{minWidth: "350px"}}/>
                            </Form.Item>
                        </Input.Group>
                    </Form.Item>

                    <Form.Item label={t('profil.landline')}>
                        <Input.Group compact={true}>

                            <Form.Item
                                name="member_tel2_prefix"
                                rules={[{required: true, message: t('formRegister.phonePrefixRequired')}]}
                            >
                                <Select
                                    style={{minWidth: "250px"}}
                                    showSearch
                                    placeholder={t('common.searchPlaceholder')}
                                    notFoundContent={t('common.noResult')}
                                    filterOption={filterPhonePrefixOption}
                                >
                                    <Select.OptGroup label={t('formRegister.preferredPrefixes')}>
                                        {FAVOURITE_PHONE_PREFIXES.map(p => (
                                            <option
                                                key={p.code + p.value}
                                                data-countrycode={p.code}
                                                value={p.value}
                                                data-search={phonePrefixSearchText(p)}
                                                data-dial={p.value.replace('+', '')}
                                            >{p.label}</option>
                                        ))}
                                    </Select.OptGroup>
                                    <Select.OptGroup label={t('formRegister.allCountries')}>
                                        {OTHER_PHONE_PREFIXES.map(p => (
                                            <option
                                                key={p.code + p.value}
                                                data-countrycode={p.code}
                                                value={p.value}
                                                data-search={phonePrefixSearchText(p)}
                                                data-dial={p.value.replace('+', '')}
                                            >{p.label}</option>
                                        ))}
                                    </Select.OptGroup>
                                </Select>

                            </Form.Item>

                            <Form.Item
                                rules={[{required: true, message: t('common.completeInfo')}]}
                                name="member_tel2"
                                initialValue={this.state.dataMembre.member_tel2}
                            >
                                <Input placeholder={t('formRegister.phoneExample')} style={{minWidth: "350px"}}/>
                            </Form.Item>
                        </Input.Group>
                    </Form.Item>


                    <Divider dashed/>
                    <Title level={4}>{t('formRegister.emergencyContact')}</Title>

                    <Form.Item
                        label={t('passport.civility')}
                        name="member_conturg_civ"
                        rules={[{required: true, message: t('profil.usernameRequired')}]}
                        initialValue={this.state.dataMembre.member_conturg_civ}
                    >
                        <Select style={{width: 120}}>
                            <option value="mr">{t('profil.mr')}</option>
                            <option value="mme">{t('profil.mme')}</option>
                        </Select>

                    </Form.Item>

                    <Form.Item
                        label={t('orderTransactions.firstName')}
                        name="member_conturg_prenom"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_conturg_prenom}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label={t('orderTransactions.lastName')}
                        name="member_conturg_nom"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_conturg_nom}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label={t('formRegister.volunteerLink')}
                        name="member_conturg_lienvolontaire"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_conturg_lienvolontaire}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label={t('formRegister.emergencyPhone')}
                        name="member_conturg_tel1"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_conturg_tel1}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label={t('formRegister.emergencyEmail')}
                        name="member_conturg_email1"
                        rules={[{type: 'email', required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_conturg_email1}
                    >
                        <Input/>
                    </Form.Item>


                    <Divider dashed/>
                    <Title level={4}>{t('formRegister.proSection')}</Title>

                    <Form.Item
                        label={t('formRegister.currentProSituation')}
                        name="member_situation"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_situation}
                    >
                        <Select>
                            {PRO_SITUATIONS.map(s => (
                                <option key={s.value} value={s.value}>{getProSituationLabel(s)}</option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label={t('formRegister.otherProSituation')}
                        name="member_situation_autre"
                        initialValue={this.state.dataMembre.member_situation_autre}
                    >
                        <Input/>
                    </Form.Item>


                    <Form.Item
                        label={t('formRegister.departureProSituation')}
                        name="member_situationdepart"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_situationdepart}
                    >
                        <Select>
                            {PRO_SITUATIONS.map(s => (
                                <option key={s.value} value={s.value}>{getProSituationLabel(s)}</option>
                            ))}
                        </Select>

                    </Form.Item>

                    <Form.Item
                        label={t('formRegister.otherDepartureProSituation')}
                        name="member_situationdepart_autre"
                        initialValue={this.state.dataMembre.member_situation_autre}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label={<div>{t('formRegister.termsAcceptIntro')}<a target="_blank"
                                                                href={THEME.urls.terms}>{t('formRegister.termsLabel')}</a>{t('formRegister.withoutReserve')}<a target="_blank"
                                                                                      href={THEME.urls.legal}>{t('formRegister.legalNoticeLabel')}</a>{t('formRegister.committedTo')}<a target="_blank"
                                                                         href={THEME.urls.internalRules}>{t('formRegister.internalRulesLabel')}</a></div>}
                        name="conditionsdv"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                    >
                        <Select style={{width: 120}}>
                            <option value="" selected="selected"></option>
                            <option value="oui">{t('formRegister.yesAccept')}</option>
                        </Select>

                    </Form.Item>

                    {/*
                    <Title level={4}>Dernière formation suivie</Title>

                    <Form.Item
                        label="Nom de l’établissement"
                        name="member_form_nom_etab"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_form_nom_etab}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label="Niveau d'étude"
                        name="member_niv_etude"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_niv_etude}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label="Spécialité"
                        name="member_specialite"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_specialite}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label="Nom de la formation"
                        name="member_nom_formation"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_nom_formation}
                    >
                        <Input/>
                    </Form.Item>

                    <Form.Item
                        label="Autres formations/compétences"
                        name="member_autre_form"
                        rules={[{required: true, message: t('common.completeInfo')}]}
                        initialValue={this.state.dataMembre.member_autre_form}
                    >
                        <Input/>
                    </Form.Item>
                    */}

                    <Form.Item
                        {...tailLayout}
                        name="member_consent_suivi_email"
                        valuePropName="checked"
                        initialValue={false}
                    >
                        <Checkbox>
                            {t('formRegister.emailTrackingConsent')}
                        </Checkbox>
                    </Form.Item>

                    {this.state.alerte}

                    <Form.Item {...tailLayout}>
                        <Button loading={this.state.loading} type="primary" htmlType="submit">
                            {t('orderBlocDetails.validateInfo')}
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        );
    }
}

export default FormRegister;